import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { PoweredByComponent } from './components/powered-by/powered-by.component';
import { MainComponent } from './components/main/main.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { MapComponent } from './components/map/map.component';
import { InfoComponent } from './components/info/info.component';
import { ArtistsListComponent } from './components/artists/list/list.component';
import { SingleComponent } from './components/artists/single/single.component';
import { PreviewComponent } from './components/artists/preview/preview.component';
import { DirectionsComponent } from './components/directions/directions.component';
import { HowtoComponent } from './components/howto/howto.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    PoweredByComponent,
    MainComponent,
    FooterComponent,
    HeaderComponent,
    MapComponent,
    InfoComponent,
    ArtistsListComponent,
    SingleComponent,
    PreviewComponent,
    DirectionsComponent,
    HowtoComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }